import('./bootstrap');

export default {};
